import('./bootstrap');

export default {};
